<div  class="flex flex-row mb-2 gap-1">
    <p class="text-[#27368A] font-extrabold text-xl ">RESERVA:</p>
    <p class="text-red-600 font-bold text-xl">#{{ detailItem.reference }}</p>
    <p class="text-gray-400 text-base flex items-end ">(oficina {{ detailItem.office }})</p>
</div>

<div class="mb-4">
    <p class="text-[#27368A] font-extrabold text-lg">Fecha y hora reservadas</p>
    <p class="text-[#8A8A8A] font-bold text-base">{{ formatDate(detailItem.date) }} - {{ detailItem.time_service }}</p>
</div>

<div class="grid grid-cols-2 mb-2">

    <div>
        <div class="mb-4">
            <p class="text-[#27368A] font-extrabold text-lg">Datos Reserva</p>
            <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Servicio: </p>
            <p class="text-[#8A8A8A] text-base"> {{ detailItem.service }}</p>
            </div>
            <div class="flex flex-row gap-1">
                <p class="text-[#8A8A8A] font-bold text-base">Personas:</p>
                <p class="text-[#8A8A8A] text-base">{{ detailItem.seats }}</p>
            </div>
            <div class="flex flex-row gap-1">
                <p class="text-[#8A8A8A] font-bold text-base">Zona:</p>
                <p class="text-[#8A8A8A] text-base">Circuito 4</p>
            </div>
        </div>

        <div class="mb-4">
        <p class="text-[#27368A] font-extrabold text-lg">Datos Titular</p>
        <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Nombre completo:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.name }}</p>
        </div>
        <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">DNI:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.vat }}</p>
        </div>
        <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.phone }}</p>
        </div>
        <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.email }}</p>
        </div>
        </div>
    </div>

    <div>
        <div class="mb-14">
            <div class="grid grid-cols-2 align-middle items-center gap-1">
                <p class="text-[#27368A] font-extrabold text-lg">Importe total: </p>
                <p class="text-[#8A8A8A] font-bold text-base">{{ detailItem.total_sell }} €</p>
            </div>
            <div class="grid grid-cols-2 mb-4">
                <p class="text-[#27368A] font-extrabold text-lg">Estado</p>
                <p class="text-center bg-[#E79418] text-white font-semibold text-base mt-1 rounded-md w-11/12">RESERVA 25%</p>
            </div>
        </div>

        <div class="mb-4">
          <p class="text-[#27368A] font-extrabold text-lg">Datos de facturación</p>
          <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Razón social:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.name }}</p>
          </div>
          <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">DNI/CIF:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.dni }}</p>
          </div>
          <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.phone }}</p>
          </div>
          <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.email }}</p>
          </div>
          <div class="flex flex-row gap-1">
            <p class="text-[#8A8A8A] font-bold text-base">Dirección:</p>
            <p class="text-[#8A8A8A] text-base">{{ detailItem.address }}</p>
          </div>
        </div>

    </div>
</div>
<div class="flex justify-end align-middle pt-3 border-t-2 border-solid border-slate-200">
    <button type="button" class="focus:outline-none text-white bg-[#42BC18] hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-[#42BC18] dark:hover:bg-green-700 dark:focus:ring-green-800">Confirmar</button>
    <button type="button" class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">Cancelar</button>
</div>
